module.exports = __webpack_public_path__ + "img/1587549.13a19269.svg";